'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};

var CANCEL =
/*#__PURE__*/
createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE =
/*#__PURE__*/
createSymbol('CHANNEL_END');
var IO =
/*#__PURE__*/
createSymbol('IO');
var MATCH =
/*#__PURE__*/
createSymbol('MATCH');
var MULTICAST =
/*#__PURE__*/
createSymbol('MULTICAST');
var SAGA_ACTION =
/*#__PURE__*/
createSymbol('SAGA_ACTION');
var SELF_CANCELLATION =
/*#__PURE__*/
createSymbol('SELF_CANCELLATION');
var TASK =
/*#__PURE__*/
createSymbol('TASK');
var TASK_CANCEL =
/*#__PURE__*/
createSymbol('TASK_CANCEL');
var TERMINATE =
/*#__PURE__*/
createSymbol('TERMINATE');
var SAGA_LOCATION =
/*#__PURE__*/
createSymbol('LOCATION');

exports.CANCEL = CANCEL;
exports.CHANNEL_END_TYPE = CHANNEL_END_TYPE;
exports.IO = IO;
exports.MATCH = MATCH;
exports.MULTICAST = MULTICAST;
exports.SAGA_ACTION = SAGA_ACTION;
exports.SAGA_LOCATION = SAGA_LOCATION;
exports.SELF_CANCELLATION = SELF_CANCELLATION;
exports.TASK = TASK;
exports.TASK_CANCEL = TASK_CANCEL;
exports.TERMINATE = TERMINATE;



//////////////////
// WEBPACK FOOTER
// ./~/@redux-saga/symbols/dist/redux-saga-symbols.cjs.js
// module id = 2957
// module chunks = 0